const DE = {
  acceptRequest: "Anfrage akzeptieren",
  accessDetail: "Zugangsdetail",
  accessoryUnavailable: "Zubehör nicht verfügbar",
  actions: "Aktionen",
  activity: "Aktivität",
  add: "Hinzufügen",
  addAgency: "Agentur hinzufügen",
  addAgencyInfoBullet1: "Angebote anfordern und direkt bestellen.",
  addAgencyInfoBullet2: "Von bestehenden Rahmenvertragspreisen profitieren.",
  addAgencyInfoBullet3: "Auf die Ressourcen zugreifen, die Sie zuweisen.",
  addAgencyInfoTitle: "Durch Hinzufügen dieser Agentur können Ihre Kunden:",
  addDocuments: "Dokumente hinzufügen",
  addEvent: "Ereignis hinzufügen",
  addFile: "Datei hinzufügen",
  addInformation: "Information hinzufügen",
  additionalInformation: "Zusätzliche Information",
  addMessageToCustomer: "Nachricht an den Kunden",
  addNewDocument: "Neues Dokument hinzufügen",
  addParticipant: "Teilnehmer hinzufügen",
  addResource: "Ressource hinzufügen",
  address: "Adresse",
  addUser: "Benutzer hinzufügen",
  agencies: "Agenturen",
  agency: "Agentur",
  agencyArchived: "Agentur archiviert",
  agencyCreated: "Agentur erstellt",
  agencyEmailDescription:
    "Alle Benachrichtigungen zu den Bestellungen der Agentur (Angebotsanfrage, Mietbeginn, Ereignis, Rückgabe usw.) werden an die Benutzer der Agentur sowie an diese E-Mail-Adresse gesendet.",
  agencyIsRequired: "Agentur ist erforderlich",
  agencyName: "Agenturname",
  agencyUpdated: "Agentur aktualisiert",
  allFilesUpToDate: "Alle Dateien sind aktuell",
  allMyOrders: "Alle meine Bestellungen",
  allResources: "Alle Ressourcen",
  alreadyCustomer: "Bereits Kunde?",
  analytics: "Analyse",
  anErrorOccurred: "Ein Fehler ist aufgetreten",
  apiStatus: "API-Status",
  applicant: "Antragsteller",
  applicationVersion: "Anwendungsversion",
  archive: "Archivieren",
  archive_one: "{{count}} Archiv",
  archive_other: "{{count}} Archive",
  archiveAgency: "Agentur archivieren",
  archiveAgencyConfirmation:
    "Sind Sie sicher, dass Sie die Agentur {{name}} archivieren möchten? Alle zugehörigen Verträge werden archiviert und ausstehende Buchungsanfragen werden storniert.",
  archived: "Archiviert",
  areYouAConstructionCompany: "Sind Sie ein Bauunternehmen?",
  areYouSureYouWantDetachResource: "Sind Sie sicher, dass Sie die Ressource von dieser Bestellung trennen möchten?",
  areYouSureYouWantDetachUser:
    "Sind Sie sicher, dass Sie diesen Benutzer von der Agentur trennen möchten? Dieser Benutzer wird per E-Mail benachrichtigt.",
  areYouSureYouWantToDelete: "Sind Sie sicher, dass Sie löschen möchten?",
  areYouSureYouWantToDeleteWithItem: "Sind Sie sicher, dass Sie {{item}} löschen möchten?",
  article: "Artikel",
  articleAccess: "Artikelzugang",
  articleCategory: "Kategorie",
  articleEquipmentUpdated: "Artikelausrüstung aktualisiert",
  articleInformation: {
    message: "Wählen Sie eine Maschine aus Ihrem internen Fuhrpark oder einen Bediener",
    warningDescription: "Fehlende Geräteinformationen. Stellen Sie die erforderlichen Dokumente und Informationen vor Mietbeginn bereit.",
    warningTitle: "Fehlende Geräteinformationen",
  },
  articleNameIsRequired: "Der Artikelname ist erforderlich",
  articles: "Artikel",
  assignment: "Zuweisung",
  associatedMachine: "Zugehörige Maschine",
  attachAResource: "Ressource auswählen",
  attachResource: "Eine Ressource zuordnen",
  availability: "Verfügbarkeit",
  available: "Verfügbar",
  backToLogin: "Zurück zum Login",
  beginning: "Beginn",
  between: "zwischen",
  billing: "Abrechnung",
  billingDetailsAssociatedWithThisOrder: "Abrechnungsdetails zu dieser Bestellung",
  billings: "Abrechnungen",
  booking: {
    addAnItem: "Element hinzufügen",
    automaticExtension: "Automatische Verlängerung",
    bankingHolidays: "Feiertage",
    date: "Datum",
    day: "Tag",
    days: "Tage",
    fromDate: "Von Datum",
    saturday: "Samstag",
    sunday: "Sonntag",
    toDate: "Bis Datum",
    useOn: "Verwenden an:",
  },
  bookingDate: "{{fromDate}} bis {{toDate}}",
  bookingEnd: "Ende der Buchung",
  bookingStart: "Beginn der Buchung",
  bookingStartTomorrow: "Die Buchung beginnt morgen",
  bookingStartTomorrowMessage:
    "Stellen Sie sicher, dass alles für die Lieferung bereit ist, die Kundenanforderungen eingehalten werden und ggf. gewünschtes Zubehör enthalten ist.",
  bookings: "Buchungen",
  brand: "Marke",
  brandIsRequired: "Die Marke ist erforderlich",
  breadcrumbs: {
    booking: {
      requests: "Nr.{{id}}",
    },
  },
  by: "von",
  byFile: "per Datei",
  cancel: "Abbrechen",
  canceled: "Storniert",
  category: "Kategorie",
  categoryName: "Kategoriename",
  ceCertificate: "CE-Zertifikat",
  changePasswordAccount: "Tracktor-Passwort ändern",
  chat: "Chatten",
  clickToUpload: "Klicken zum Hochladen",
  client: "Kunde",
  clientRequest: "Kundenanfrage",
  clients: "Kunden",
  clientWillBeNotifiedByEmail: "Der eingeladene Benutzer wird per E-Mail benachrichtigt.",
  close: "Schließen",
  closed: "Geschlossen",
  closedAt: "Geschlossen am {{date}}",
  closedAtIncidentAlert: "Geschlossen am {{date}} von {{by}}",
  closeTheIncident: "Vorfall schließen",
  code: "Code",
  codeOrKeysLocation: "Code oder Standort der Schlüssel",
  commandPosts: "Kommandoposten",
  company: "Unternehmen",
  completed: "Abgeschlossen",
  confirm: "Bestätigen",
  confirmed: "Bestätigt",
  contactAction: "Kontaktieren",
  contacts: "Kontakte",
  continue: "Fortfahren",
  couldNotFindBookingItem: "Buchungselement konnte nicht gefunden werden",
  countryCode: "Ländercode",
  createAPasswordForYourAccount: "Erstellen Sie ein Passwort für Ihr Konto",
  createNewResource: "Neue Ressource erstellen",
  createNewUser: "Neuen Benutzer erstellen",
  createYourFirstConversation: "Erstellen Sie Ihre erste Unterhaltung",
  currentApiVersion: "Aktuelle API-Version",
  currentApiVersionUsed: "Verwendete API-Version",
  darkMode: "Dunkler Modus",
  darkTheme: "Dunkles Thema",
  dashboard: "Dashboard",
  dataSheet: "Datenblatt",
  date: {
    endDate: "Enddatum",
    startDate: "Startdatum",
  },
  dates: "Daten",
  dayCount_one: "{{count}} Tag",
  dayCount_other: "{{count}} Tage",
  deals: "Angebote",
  dealsView: {
    detailed: "Detailliert",
    grouped: "Gruppiert",
    kanban: "Kanban",
    list: "Liste",
    planning: "Planung",
  },
  delete: "Löschen",
  deleteBookingFileMessage: "Sind Sie sicher, dass Sie diese Datei aus der Buchung löschen möchten?",
  deleteConversation: "Unterhaltung löschen",
  deleteFile: "Datei löschen",
  deleteFileConfirmation: "Das Löschen der Datei ist unwiderruflich. Möchten Sie fortfahren?",
  deleteResource: "Ressource löschen",
  deleteResourceConfirmation: "Das Löschen einer Ressource ist unwiderruflich und löscht alle verknüpften Dateien. Möchten Sie fortfahren?",
  delivery: "Lieferung",
  deliveryAndReturn: "Lieferung und Rückgabe",
  deliveryTimeConstraint: "Lieferzeitbeschränkung",
  designation: "Bezeichnung",
  detach: "Trennen",
  detachResource: "Ressource trennen",
  detachUser: "Benutzer trennen",
  detachUserSuccessfully: "Benutzer erfolgreich getrennt",
  document: "Dokument",
  documentAdded: "Dokument hinzugefügt",
  documentDeleted: "Dokument gelöscht",
  documentExp: "Dok. Ablauf",
  documentIssue_one: "{{count}} Dok. ausstehend",
  documentIssue_other: "{{count}} Dok. ausstehend",
  documentIssueTooltip_one: "{{count}} fehlendes oder abgelaufenes Dokument",
  documentIssueTooltip_other: "{{count}} fehlende oder abgelaufene Dokumente",
  documentMissing_one: "{{count}} Dok. fehlt",
  documentMissing_other: "{{count}} Dok. fehlen",
  documentName: "Dokumentname",
  documents: "Dokumente",
  documentsOk: "Dok. OK",
  documentType: "Dokumenttyp",
  documentUpdated: "Dokument aktualisiert",
  edit: "Bearbeiten",
  editInfoDocument: "Dokumentinformationen bearbeiten",
  editMyPassword: "Mein Passwort bearbeiten",
  editResource: "Ressource bearbeiten",
  editUser: "Benutzer bearbeiten",
  email: "E-Mail",
  emailSent: "E-Mail gesendet",
  emailSentForgotPassword: "Eine E-Mail zum Zurücksetzen Ihres Passworts wurde gesendet.",
  emptyBooking: "Sie haben keine bevorstehenden Buchungen",
  emptyBookingMissing: "Sie haben keine verpassten Anfragen",
  emptyState: {
    noDealsFound: "Sie haben noch keine Bestellung",
    noDealsFoundDescription: "Ihre neuen Bestellungen werden in dieser Tabelle angezeigt.",
    pageNotFoundDescription:
      "Die von Ihnen gesuchte Seite konnte nicht gefunden werden. Bitte überprüfen Sie die URL oder gehen Sie zur vorherigen Seite zurück.",
    returnToOrders: "Zurück zu den Bestellungen",
  },
  end: "Ende",
  enterTheCode: "Code eingeben",
  enterToSend: "↵ Eingabe zum Senden · ⇧ Shift+↵ Eingabe für neue Zeile",
  enterYourCode: "Geben Sie Ihren Code ein",
  enterYourMessage: "Geben Sie Ihre Nachricht ein",
  entity: "Entität",
  equipment: "Ausrüstung",
  equipmentInformation: {
    maximumPlates: "Maximale Last auf der Platte (t)",
    sizePlates: "Größe der Verteilplatten (m²)",
    skid: "Maximaler Druck unter der Verteilplatte (t/m²)",
  },
  equipmentNotOffered: "Ausrüstung nicht angeboten",
  error: {
    missingArticle: "Fehlender Artikel",
    missingDates: "Fehlende Daten",
    missingQuantity: "Fehlende Menge",
    missingUnitPrice: "Fehlender Stückpreis",
    noBookingFound: "Keine Buchung gefunden",
    noClientFoundForThisRequest: "Für diese Anfrage wurde kein Kunde gefunden",
    pleaseFillFields: "Bitte füllen Sie alle erforderlichen Felder aus",
    pleaseSelectArticleBeforeAddingNewOne: "Bitte wählen Sie einen Artikel aus, bevor Sie einen neuen hinzufügen",
    positiveValueOnly: "Nur positive Werte sind erlaubt",
    resourceMustBeSelected: "Es muss eine Ressource ausgewählt werden",
    selectDates: "Bitte wählen Sie gültige Daten aus",
    shouldBeANumber: "Sollte eine Zahl sein",
    someRequestDataAreMissing: "Einige Anfragedaten fehlen",
    unknownError: "Unbekannter Fehler, bitte versuchen Sie es erneut",
  },
  error404: "Fehler 404",
  errorLoadingRequests: "Beim Laden der Anfragen ist ein Fehler aufgetreten",
  escape: "Escape",
  eventStatus: {
    accepted: "Mietanfrage akzeptiert",
    canceled: "Mietanfrage storniert",
    refused: "Mietanfrage abgelehnt",
    sent: "Mietanfrage erhalten",
  },
  eventUpdated: "Ereignis aktualisiert",
  expirationDate: "Ablaufdatum",
  expired: "Abgelaufen",
  file: "die Datei",
  fileAddedSuccessfully: "Datei erfolgreich hinzugefügt",
  fileArchivedSuccessfully: "Datei erfolgreich archiviert",
  fileDeletedSuccessfully: "Datei erfolgreich gelöscht",
  fileHasBeenUploaded: "Die Datei wurde hochgeladen",
  fileName: "Dateiname",
  fileStatus: {
    expired: "Abgelaufen",
    expires_soon: "Läuft bald ab",
    up_to_date: "Aktuell",
  },
  files: "Dateien",
  filesNotUpToDate: "Einige Dateien sind nicht aktuell",
  fileType: "Dateityp",
  fileUnarchivedSuccessfully: "Datei erfolgreich entarchiviert",
  finish: "Fertig",
  finishDayCount: "Diese Frist endet in {{count}} Tagen",
  finishToday: "Endet heute",
  finishTomorrow: "Endet morgen",
  firstName: "Vorname",
  flatRate: "Pauschale",
  fleetNumber: "Flottennummer",
  forgottenPassword: "Passwort vergessen",
  forgottenPasswordSubtitle: "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
  form: {
    constraint: {
      password: "Das Passwort muss mindestens 8 Zeichen und einen Großbuchstaben enthalten",
    },
    validation: {
      required: "Dieses Feld ist erforderlich",
    },
  },
  generalTerms: "Allgemeine Geschäftsbedingungen",
  getSupport: "Hilfe erhalten",
  giveFeedback: "Feedback geben",
  globalSearchPlaceholder: "Geben Sie eine Angebots-ID oder einen Artikelnamen ein",
  happyToSeeYouAgain: "Schön, Sie wiederzusehen!",
  help: "Hilfe",
  helperText: {
    onlyImageFilesAreAllowed: "Nur .png, .jpeg, .pdf Dateien sind erlaubt",
  },
  history: "Verlauf",
  home: "Startseite",
  icon: "Icon",
  identity: "Identität",
  identityCard: "Personalausweis",
  import: "Importieren",
  importFile: "Datei importieren",
  incidentAddedSuccessfully: "Vorfall erfolgreich hinzugefügt",
  incidentClosed: "Vorfall geschlossen",
  incidentOpened: "Vorfall geöffnet",
  indicateCodeOrKeysLocation: "Geben Sie den Code oder den Standort der Schlüssel an",
  information: "Information",
  informations: "Informationen",
  inProgress: "In Bearbeitung",
  instructionManual: "Bedienungsanleitung",
  insurance: "Versicherung",
  internalCode: "Interner Code",
  internalCodeIsRequired: "Der interne Code ist erforderlich",
  invoice: "Rechnung",
  irreversibleAction: "Diese Aktion ist unwiderruflich",
  key: "Schlüssel",
  keyLocation: "Schlüsselstandort",
  keys: "Schlüssel",
  language: "Sprache",
  lastName: "Nachname",
  linkDocuments: "Dokumente verknüpfen",
  linkDocumentsToBooking: "Für den Kunden sichtbare Dokumente",
  list: "Liste",
  logIn: "Melden Sie sich an",
  login: "Anmelden",
  logout: "Abmelden",
  machine: "Maschine",
  machineRegistration: "Maschinenregistrierung",
  mail: "E-Mail",
  maintenanceLog: "Wartungsprotokoll",
  makeAnOffer: "Angebot machen",
  material: "Material",
  materialDropOffPoint: "Materialabgabestelle",
  messagePlaceholder: "Maximale Traglast am Gleitkufen (T), Abmessungen der Verteilungsplatten (m²)…",
  messages: "Nachrichten",
  messageToCustomer: "Nachricht an den Kunden",
  missed: "Verpasst",
  missingRole: "Fehlende Rolle",
  modifyMyOffer: "Mein Angebot ändern",
  modifyOffer: "Angebot ändern",
  myProfile: "Mein Profil",
  name: "Name",
  newConversation: "Neue Unterhaltung",
  newDate: "Neues Datum",
  newDateProposal: "Ab einem anderen nahen Datum verfügbar",
  newDocument: "Neues Dokument",
  newMessage: "Neue Nachricht",
  newMessageCount_one: "{{count}} neue Nachricht",
  newMessageCount_other: "{{count}} neue Nachrichten",
  newPassword: "Neues Passwort",
  newPasswordConfirm: "Neues Passwort bestätigen",
  newResourceCreated: "Ihre neue Ressource wurde erstellt!",
  newResourceCreatedDetails: "Laden Sie Dokumente und deren Gültigkeitsdaten hoch.",
  next: "Weiter",
  nextAssignment: "Nächste Zuweisung",
  no: "Nein",
  noAgenciesFound: "Keine Agenturen gefunden",
  noAvailability: "Keine Verfügbarkeit und Downgrade unmöglich",
  noDocumentsFound: "Keine Dokumente gefunden",
  noEvents: "Keine Ereignisse",
  noFilesAttached: "Keine Dateien angehängt",
  noNameFound: "Kein Name gefunden",
  noOrderFound: "Keine Bestellung zu diesem Artikel gefunden",
  notAvailable: "Nicht verfügbar",
  notes: "Notizen",
  notFound: "Die gesuchte Seite wurde nicht gefunden.",
  notFoundRedirection: "Bitte überprüfen Sie die URL oder gehen Sie zur vorherigen Seite zurück.",
  noUsersFound: "Keine Benutzer gefunden",
  num: "Nr.",
  numberOfDays: "Anzahl der Tage",
  numberParc: "Parkplatznummer",
  numberParcShort: "Park-Nr.",
  offerSendTo: "Ihr Angebot wurde an {{name}} gesendet",
  offerSendToDetails: "Sie werden benachrichtigt, sobald Ihr Kunde Ihr Angebot akzeptiert.",
  onboarding: {
    featureRequests: {
      step1Description:
        "Kunden sehen auf Tracktor sofort die Lieferanten in der Nähe ihrer Baustelle, sortiert nach Entfernung und Rahmenvertragspreisen.",
      step1Title: "Steigern Sie Ihre Einnahmen",
      step2Description:
        "Füllen Sie Ihr Angebot aus und senden Sie es ab. Wenn Sie schnell und mit einem attraktiven Preis antworten, erhöhen Sie Ihre Chancen, vom Kunden ausgewählt zu werden!",
      step2Title: "Antworten Sie mit nur wenigen Klicks",
    },
  },
  open: "Offen",
  openFullPage: "Auf ganzer Seite öffnen",
  openFullScreen: "In voller Bildschirmgröße öffnen",
  operator: "Bediener",
  operatorDocExp: "Bed. abgel.",
  operatorDocKo: "Bed. KO",
  operatorDocMissing_one: "{{count}} Bed. fehlend",
  operatorDocMissing_other: "{{count}} Bed. fehlend",
  operatorDocument: "Bedienerdokument",
  order: "Bestellung",
  orderHistory: "Bestellverlauf",
  orderSummary: "Bestellübersicht",
  orders: "Bestellungen",
  other: "Andere",
  oups: "Hoppla!",
  overview: "Übersicht",
  pageNotFound: "Seite nicht gefunden",
  participants: "Teilnehmer",
  password: "Passwort",
  passwordSetSuccessfully: "Ihr Passwort wurde aktualisiert",
  passwordsNotMatching: "Passwörter stimmen nicht überein",
  passwordUpdated: "Ihr Passwort wurde aktualisiert",
  payments: "Zahlungen",
  periodicGeneralInspection: "Wiederkehrende Hauptuntersuchung (PGI)",
  phone: "Telefon",
  phoneNumber: "Telefonnummer",
  planning: "Planung",
  pleaseSetAPassword: "Bitte legen Sie ein Passwort fest",
  price: "Preis",
  priceExVAT: "Ohne MwSt.",
  profile: "Mein Profil",
  profileUpdated: "Ihr Profil wurde aktualisiert",
  purchaseOrder: "Bestellauftrag",
  purchaseOrderNumber: "Bestellnummer",
  quantity: "Menge",
  quote: "Angebot",
  reason: "Grund",
  received: "Erhalten",
  refuse: "Ablehnen",
  refused: "Abgelehnt",
  refusedBookingRequestMessage: "Wenn Sie diese Buchungsanfrage ablehnen, können Sie sie später nicht mehr akzeptieren.",
  refusedTheBooking: "Bestellung abgelehnt",
  refuseRequest: "Anfrage ablehnen",
  releaseNotRequested: "Der Kunde hat die Freigabe noch nicht angefordert",
  releaseRequestedForDate: "Freigabe angefordert für {{date}}",
  reload: "Neu laden",
  rentalRequests: "Anfragen",
  reopenTheIncident: "Vorfall wieder öffnen",
  replace: "Ersetzen",
  request: "Anfrage",
  requestMissedAlert: {
    button: "Zurück zu meinen Anfragen",
    description1: "Der Kunde hat diese Anfrage an mehrere Anbieter gesendet und eines ihrer Angebote angenommen.",
    description2:
      "Auf Tracktor antworten Anbieter im Durchschnitt in weniger als einer Stunde: Seien Sie reaktionsschnell, um Ihre Chancen auf zukünftige Aufträge zu maximieren.",
    redirection: "👉 Erfahren Sie mehr über die Anbietersuche auf Tracktor",
    title: "Verpasste Anfragen",
  },
  requestOfferAlertInfoDescription:
    "Die Antwort auf jede Anfrage (auch bei Ablehnung) erhöht Ihre Chancen, von diesem Kunden erneut kontaktiert zu werden, um 65%.",
  requestOfferAlertInfoTitle: "Keine Gelegenheit verpassen",
  requestStatus: {
    expired: "Abgelaufen",
    proposed: "Vorgeschlagen",
    refused: "Abgelehnt",
    toTreat: "Zu bearbeiten",
  },
  requests: "Anfragen",
  requestWithID: "Anfragen Nr.{{id}}",
  required: "Erforderlich",
  reservation: "Reservierung",
  reservationRequestAccepted: "Reservierungsanfrage akzeptiert, die Bestellung wurde erstellt",
  reservationRequestInfo:
    "Mit der Annahme wird diese Anfrage automatisch in eine Bestellung zu den oben genannten Bedingungen umgewandelt. Sie erscheint in Ihren Bestellungen und der Kunde wird informiert.",
  resetInitialRequest: "Ursprüngliche Anfrage zurücksetzen",
  resetPassword: "Passwort zurücksetzen",
  resource: "Ressource",
  resourceAddedSuccessfully: "Ressource erfolgreich hinzugefügt",
  resourceCreated: "Ressourcen erstellt",
  resourceDetachedSuccessfully: "Ressource erfolgreich getrennt",
  resourceEmptyState: {
    button: "Fügen Sie Ihre erste Ressource hinzu",
    dialogContentText:
      "Fügen Sie mehrere Ressourcen auf einmal hinzu, indem Sie eine Datei (CSV, XLS, XLSX, PDF...) importieren oder manuell hinzufügen.",
    dialogPrimaryButton: "Manuell hinzufügen",
    dialogSecondaryButton: "Datei importieren",
    dialogSuccessContentText:
      "Die Verarbeitung Ihrer Ressourcen läuft. Sie werden bald in Ihrem Bereich verfügbar sein und Sie werden per E-Mail benachrichtigt.",
    dialogSuccessTitle: "Übertragene Ressourcen",
    dialogTitle: "Wählen Sie Ihre Methode",
    listSubtitle1: "Fügen Sie Ihrem Bereich eine neue Ressource hinzu",
    listSubtitle2: "Und geben Sie die Gültigkeitsdaten an",
    listSubtitle3: "Alle Dokumente werden an den Kunden gesendet",
    listTitle1: "Ressource speichern",
    listTitle2: "Dokumente hinzufügen",
    listTitle3: "Einer Bestellung zuweisen",
    title: "Fügen Sie Ihre erste Ressource hinzu und vereinfachen Sie die Verwaltung Ihrer Bestellungen",
  },
  resourceName: "Ressourcenname",
  resourcePhoto: "Ressourcenfoto",
  resourcePhotoHelperText: "PNG oder JPG (max. 5 MB)",
  resourceSearchPlaceholder: "Zum Suchen eingeben (Modell, Fuhrparknummer)",
  resources: "Ressourcen",
  resourceUpdated: "Ressourcen aktualisiert",
  resourceUpdatedSuccessfully: "Ressource erfolgreich aktualisiert",
  respondToDemand: "Auf Anfrage antworten",
  return: "Rückgabe",
  returnTo: "Zurück zu",
  role: "Rolle",
  save: "Speichern",
  saveChanges: "Änderungen speichern",
  search: "Suchen",
  searchContacts: "Kontakte suchen",
  searchInApp: "In der App suchen",
  see: "Ansehen",
  seeDetail: "Details ansehen",
  seeOffer: "Angebot ansehen",
  seeTheLines: "Zeilen anzeigen",
  seeTheResource: "Ressource ansehen",
  selectAnAgency: "Agentur auswählen",
  selectAnAgencyToAttachCategory: "Wählen Sie eine Agentur aus, um diese Kategorie zuzuweisen",
  selectAnotherResource: "Andere Ressource auswählen",
  selectDocumentType: "Dokumenttyp auswählen",
  selectExpirationDate: "Ablaufdatum auswählen",
  selectResource: "Ressource auswählen",
  selectResourceWarning:
    "Durch die Auswahl dieser Ressource bestätigen Sie, dass sie den Anforderungen des Kunden entspricht. Ihr Kunde wird per E-Mail benachrichtigt.",
  send: "Senden",
  sendOffer: "Angebot senden",
  sent: "Gesendet",
  serialNumber: "Seriennummer",
  service: "Dienstleistung",
  settings: "Einstellungen",
  siret: "SIRET / DNS-Nummer",
  siretMustBe14Characters: "SIRET muss genau 14 Zeichen lang sein",
  sorenAnnouncement: {
    badge: "Bald Soren",
    badgeSwitched: "Jetzt Soren",
    badgeSwitchedTooltip: "Tracktor ist jetzt Soren – mehr erfahren",
    badgeTooltip: "Tracktor wird zu Soren – mehr erfahren",
    gotIt: "Verstanden",
    readArticle: "Ankündigung lesen",
    story: {
      goToCard: "Karte {{count}}",
      nextCard: "Nächste Karte",
      previousCard: "Vorherige Karte",
      switchTitle: "Tracktor ändert bis zum {{date}} seinen Namen.",
      switchTitlePast: "Tracktor hat am {{date}} seinen Namen geändert.",
      switchTitleToday: "Tracktor ändert heute seinen Namen.",
      thanksBody: "Für Ihre Maschinen, Ihre Teams und Ihr Vertrauen.",
      thanksBodyOrders_one: "{{number}} gemeinsame Bestellung. Für Ihre Maschinen, Ihre Teams und Ihr Vertrauen.",
      thanksBodyOrders_other: "{{number}} gemeinsame Bestellungen. Für Ihre Maschinen, Ihre Teams und Ihr Vertrauen.",
      thanksTitle: "Danke, {{name}}.",
      thanksTitleAnonymous: "Danke.",
    },
    unchanged: {
      accessTitle: "Gleiche Zugänge",
      contactsTitle: "Gleiche Ansprechpartner",
      ordersTitle: "Gleiche Aufträge und Kunden",
      title: "Nichts ändert sich außer dem Namen und dem Logo.",
    },
  },
  startDayCount: "Beginnt in {{count}} Tagen",
  startToday: "Beginnt heute",
  startTomorrow: "Beginnt morgen",
  status: "Status",
  supplier: "Lieferant",
  supplierComment: "Kommentar des Lieferanten",
  TECHNICAL_SHEET: "Technisches Datenblatt",
  theBookingRequestHasBeenAccepted: "Ihr Angebot wurde gesendet",
  theBookingRequestHasBeenRefused: "Die Buchungsanfrage wurde abgelehnt",
  to: "Bis",
  to_add: "Hinzufügen",
  toAdd: "Hinzufügen",
  toCome: "Bevorstehend",
  toDo: "Zu erledigen",
  today: "Heute",
  tokenVerification: "Token-Verifizierung",
  total: "Gesamt",
  totalHT: "Gesamt ohne MwSt.",
  toUpdate: "Zu aktualisieren",
  type: "Typ",
  typeToSearch: "Zum Suchen tippen",
  unarchive: "Entarchivieren",
  units: {
    DAYS_one: "{{count}} Tag",
    DAYS_other: "{{count}} Tage",
    HOURS_one: "{{count}} Stunde",
    HOURS_other: "{{count}} Stunden",
    KM: "{{count}} Km",
    null: "{{count}} ",
    unit: "Einheit",
    units: "Einheit",
    units_one: "{{count}} Einheit",
    units_other: "{{count}} Einheiten",
  },
  up_to_date: "Aktuell",
  uploadFile: "Datei hochladen",
  upToDate: "Aktuell",
  userHasBeenAttachedToAgency: "Der Benutzer wurde der Agentur zugewiesen",
  users: "Benutzer",
  usersActions: {
    archiveUser: "Benutzer archivieren",
    archiveUserSuccessfully: "Benutzer erfolgreich archiviert",
    areYouSureYouWantToArchiveThisUser:
      "Sind Sie sicher, dass Sie diesen Benutzer archivieren möchten? Dieser Benutzer hat keinen Zugang mehr zum Agenturbereich und wird per E-Mail benachrichtigt.",
    unarchiveUser: "Benutzer wiederherstellen",
    unarchiveUserDescription:
      "Durch das Wiederherstellen dieses Benutzers erhält er erneut Zugriff auf den Agenturbereich und wird per E-Mail benachrichtigt.",
    unarchiveUserSuccessfully: "Benutzer erfolgreich wiederhergestellt",
    userCreatedSuccessfully: "Benutzer erfolgreich erstellt",
    userUpdatedSuccessfully: "Benutzer erfolgreich aktualisiert",
  },
  userUnarchivedSuccessfully: "Benutzer erfolgreich dearchiviert",
  validate: "Validieren",
  worksiteAccessConstraints: "Zugangsbeschränkungen zur Baustelle",
  writeAMessage: "Nachricht schreiben...",
  yes: "Ja",
  yesterday: "Gestern",
  yourAccount: "Ihr Konto",
  yourClientWillBeNotifiedByEmail: "Ihr Kunde wird per E-Mail benachrichtigt",
  yourOffer: "Ihr Angebot",
  yourOrdersAreWaitingForYouLogin: "Ihre Bestellungen warten auf Sie, bitte anmelden!",
  yourResourcesWillBeAddedToYourSpaceAfterProcessing: "Ihre Ressourcen werden nach der Verarbeitung Ihrem Bereich hinzugefügt",
} as const;

export default DE;
